var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 777.77,
    height: 255.123,
    viewBox: "0 0 777.77 255.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2dda60}.cls-2{fill:#2d6fda}.cls-3{fill:#efff14}.cls-4{fill:#ff6e14}.cls-5{fill:#d100c9}.cls-6{fill:#8fdfff}.cls-7{fill:#8844e2}.cls-8{fill:#8be239}.cls-9{fill:#ffc44d}.cls-10{fill:#40dfff}.cls-11{fill:#fc6665}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_384",
    "data-name": "Gruppe 384",
    transform: "translate(-183.618 -138.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_365",
    "data-name": "Gruppe 365",
    transform: "translate(183.618 138.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_364",
    "data-name": "Gruppe 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_128",
    "data-name": "Gruppe 128",
    transform: "translate(10.199 57.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_79",
    "data-name": "Gruppe 79",
    transform: "translate(609.799 72.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_78",
    "data-name": "Gruppe 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_746",
    d: "M1460.356 405.334l-.667 2.473-2.764-.131 1.4-1.868z",
    className: "cls-1",
    "data-name": "Pfad 746",
    transform: "translate(-1456.925 -405.334)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_81",
    "data-name": "Gruppe 81",
    transform: "translate(593.556 15.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_80",
    "data-name": "Gruppe 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_747",
    d: "M1428.419 287.962l.083 3.362-3.14-.154-1.8-4.549z",
    className: "cls-1",
    "data-name": "Pfad 747",
    transform: "translate(-1423.567 -286.621)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_83",
    "data-name": "Gruppe 83",
    transform: "translate(566.395 17.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_82",
    "data-name": "Gruppe 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_748",
    d: "M1371.082 294.911l-3.3-.454.031-3.436 3.859.172z",
    className: "cls-1",
    "data-name": "Pfad 748",
    transform: "translate(-1367.786 -291.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_85",
    "data-name": "Gruppe 85",
    transform: "translate(551.998 66.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_84",
    "data-name": "Gruppe 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_749",
    d: "M1340.385 395.721l-2.167-.017.119-2.848 4.129-.187z",
    className: "cls-1",
    "data-name": "Pfad 749",
    transform: "translate(-1338.219 -392.668)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_87",
    "data-name": "Gruppe 87",
    transform: "translate(548.986 113.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_86",
    "data-name": "Gruppe 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_750",
    d: "M1335.051 491.722l-3.018-1.047 1.682-2.283 2.335.67z",
    className: "cls-1",
    "data-name": "Pfad 750",
    transform: "translate(-1332.033 -488.392)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_89",
    "data-name": "Gruppe 89",
    transform: "translate(532.008 102.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_88",
    "data-name": "Gruppe 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_751",
    d: "M1301.273 466.75l-1.055 3.651-2.455-1.119-.6-3.115z",
    className: "cls-1",
    "data-name": "Pfad 751",
    transform: "translate(-1297.163 -466.166)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_91",
    "data-name": "Gruppe 91",
    transform: "translate(471.356 32.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_90",
    "data-name": "Gruppe 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_752",
    d: "M1177.768 324.046l-2.767 3.18-2.4-1.954 1.436-2.113z",
    className: "cls-1",
    "data-name": "Pfad 752",
    transform: "translate(-1172.601 -323.158)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_93",
    "data-name": "Gruppe 93",
    transform: "translate(436.654 59.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_92",
    "data-name": "Gruppe 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_753",
    d: "M1103.722 378.276l-1.245 1.292-1.145-.642.577-1.447z",
    className: "cls-1",
    "data-name": "Pfad 753",
    transform: "translate(-1101.332 -377.48)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_95",
    "data-name": "Gruppe 95",
    transform: "translate(399.127 120.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_94",
    "data-name": "Gruppe 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_754",
    d: "M1029.083 505.19l.023 3.069-3.944 1.009-.9-5.666z",
    className: "cls-1",
    "data-name": "Pfad 754",
    transform: "translate(-1024.262 -503.601)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_97",
    "data-name": "Gruppe 97",
    transform: "translate(390.605 52.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_96",
    "data-name": "Gruppe 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_755",
    d: "M1013.8 365.166l-3.225 3.771-3.817-.383 1.006-5.459z",
    className: "cls-1",
    "data-name": "Pfad 755",
    transform: "translate(-1006.761 -363.095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_99",
    "data-name": "Gruppe 99",
    transform: "translate(380.121 109.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_98",
    "data-name": "Gruppe 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_756",
    d: "M987.583 480.416l.75 2.321-2.012-.505-1.091-1.652z",
    className: "cls-1",
    "data-name": "Pfad 756",
    transform: "translate(-985.23 -480.416)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_101",
    "data-name": "Gruppe 101",
    transform: "translate(330.282 29.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_100",
    "data-name": "Gruppe 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_757",
    d: "M886.92 319.139l-2.838 2.187-1.209-2.029 1.017-2.9z",
    className: "cls-1",
    "data-name": "Pfad 757",
    transform: "translate(-882.874 -316.394)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_103",
    "data-name": "Gruppe 103",
    transform: "translate(285.104 96.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_102",
    "data-name": "Gruppe 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_758",
    d: "M795.885 456.578l-3.141 2.656-2.654-3.278 3.32-2.913z",
    className: "cls-1",
    "data-name": "Pfad 758",
    transform: "translate(-790.09 -453.043)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_105",
    "data-name": "Gruppe 105",
    transform: "translate(249.252 70.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_104",
    "data-name": "Gruppe 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_759",
    d: "M723.925 406.482l-5.195-1.226-2.27-4.386 5.592-.032z",
    className: "cls-1",
    "data-name": "Pfad 759",
    transform: "translate(-716.461 -400.838)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_107",
    "data-name": "Gruppe 107",
    transform: "translate(238.476 73.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_106",
    "data-name": "Gruppe 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_760",
    d: "M699.059 413.168l-4.468-2.024-.262-4.053 3.667 1.4z",
    className: "cls-1",
    "data-name": "Pfad 760",
    transform: "translate(-694.329 -407.091)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_109",
    "data-name": "Gruppe 109",
    transform: "translate(213.583 61.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_108",
    "data-name": "Gruppe 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_761",
    d: "M644.249 382.449l-.216.849-.808.136-.02-1z",
    className: "cls-1",
    "data-name": "Pfad 761",
    transform: "translate(-643.205 -382.439)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_111",
    "data-name": "Gruppe 111",
    transform: "translate(152.742 124.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_110",
    "data-name": "Gruppe 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_762",
    d: "M521.919 514.667l-3.263-.417-.4-3.314 2.722 1.034z",
    className: "cls-1",
    "data-name": "Pfad 762",
    transform: "translate(-518.255 -510.936)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_113",
    "data-name": "Gruppe 113",
    transform: "translate(149.968 15.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_112",
    "data-name": "Gruppe 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_763",
    d: "M514.79 289.613l-1.592.243-.639-1.374 1.865-1.043z",
    className: "cls-1",
    "data-name": "Pfad 763",
    transform: "translate(-512.558 -287.438)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_115",
    "data-name": "Gruppe 115",
    transform: "translate(129.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_114",
    "data-name": "Gruppe 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_764",
    d: "M472.108 256.064l-.455 1.112-1.187-.387.55-1.056z",
    className: "cls-1",
    "data-name": "Pfad 764",
    transform: "translate(-470.466 -255.732)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_117",
    "data-name": "Gruppe 117",
    transform: "translate(65.939 80.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_116",
    "data-name": "Gruppe 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_765",
    d: "M342.79 420.709l1.451 3.561-4.217 1.008-.039-3.585z",
    className: "cls-1",
    "data-name": "Pfad 765",
    transform: "translate(-339.985 -420.709)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_119",
    "data-name": "Gruppe 119",
    transform: "translate(63.835 112.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_118",
    "data-name": "Gruppe 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_766",
    d: "M337.438 487.634l-1.14.782-.633-1.36 1.324-.757z",
    className: "cls-1",
    "data-name": "Pfad 766",
    transform: "translate(-335.665 -486.299)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_121",
    "data-name": "Gruppe 121",
    transform: "translate(62.491 6.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_120",
    "data-name": "Gruppe 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_767",
    d: "M335.375 272.5l-2.471-.774.987-2.515 4.832-.111z",
    className: "cls-1",
    "data-name": "Pfad 767",
    transform: "translate(-332.904 -269.101)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_123",
    "data-name": "Gruppe 123",
    transform: "translate(27.112 122.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_122",
    "data-name": "Gruppe 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_768",
    d: "M263.781 509.394l-2.125 2.6-1.411-2.874 1.851-2.819z",
    className: "cls-1",
    "data-name": "Pfad 768",
    transform: "translate(-260.244 -506.302)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_125",
    "data-name": "Gruppe 125",
    transform: "translate(20.071 46.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_124",
    "data-name": "Gruppe 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_769",
    d: "M247.015 351.9l-.212 1.016-.884-.287-.135-1.244z",
    className: "cls-1",
    "data-name": "Pfad 769",
    transform: "translate(-245.784 -351.389)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_127",
    "data-name": "Gruppe 127",
    transform: "translate(0 105.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_126",
    "data-name": "Gruppe 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_770",
    d: "M211.172 474.108l-2.765 3.665-3.843-2.677 3.051-2.617z",
    className: "cls-1",
    "data-name": "Pfad 770",
    transform: "translate(-204.564 -472.479)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_171",
    "data-name": "Gruppe 171",
    transform: "translate(108.549 48.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_130",
    "data-name": "Gruppe 130",
    transform: "translate(0 56.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_129",
    "data-name": "Gruppe 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_771",
    d: "M406.548 356.339l1.03-1.18.755.937-.432 1.433z",
    className: "cls-2",
    "data-name": "Pfad 771",
    transform: "translate(-406.548 -355.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_132",
    "data-name": "Gruppe 132",
    transform: "translate(42.553 12.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_131",
    "data-name": "Gruppe 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_772",
    d: "M493.94 265.154l2.82-1.614.9 2.633-1.776.562z",
    className: "cls-2",
    "data-name": "Pfad 772",
    transform: "translate(-493.94 -263.54)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_134",
    "data-name": "Gruppe 134",
    transform: "translate(61.15 113.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_133",
    "data-name": "Gruppe 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_773",
    d: "M532.133 473.516l.758-2.82 1.787 1.08.294 1.963z",
    className: "cls-2",
    "data-name": "Pfad 773",
    transform: "translate(-532.133 -470.696)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_136",
    "data-name": "Gruppe 136",
    transform: "translate(76.197 6.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_135",
    "data-name": "Gruppe 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_774",
    d: "M563.036 253.728l.35-2.179 1.81.395-.026 1.765z",
    className: "cls-2",
    "data-name": "Pfad 774",
    transform: "translate(-563.036 -251.549)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_138",
    "data-name": "Gruppe 138",
    transform: "translate(87.713 107.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_137",
    "data-name": "Gruppe 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_775",
    d: "M586.686 460.884l3.061-1.951 1.368 2.712-2.268 2.518z",
    className: "cls-2",
    "data-name": "Pfad 775",
    transform: "translate(-586.686 -458.933)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_140",
    "data-name": "Gruppe 140",
    transform: "translate(151.259 90.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_139",
    "data-name": "Gruppe 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_776",
    d: "M717.267 424.868l1.9 1.094-.32 1.591-1.655-.43z",
    className: "cls-2",
    "data-name": "Pfad 776",
    transform: "translate(-717.192 -424.868)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_142",
    "data-name": "Gruppe 142",
    transform: "translate(163.275 87.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_141",
    "data-name": "Gruppe 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_777",
    d: "M741.87 419.98l1.914-2.369 2.447 1.583-1.763 2.213z",
    className: "cls-2",
    "data-name": "Pfad 777",
    transform: "translate(-741.87 -417.611)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_144",
    "data-name": "Gruppe 144",
    transform: "translate(167.618 96.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_143",
    "data-name": "Gruppe 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_778",
    d: "M750.79 438.14l1.384-2.4 2.759.641-1.565 2.164z",
    className: "cls-2",
    "data-name": "Pfad 778",
    transform: "translate(-750.79 -435.736)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_146",
    "data-name": "Gruppe 146",
    transform: "translate(196.73 135.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_145",
    "data-name": "Gruppe 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_779",
    d: "M810.578 519.159l3.2-2.386-.266 3.776-2.6 2.281z",
    className: "cls-2",
    "data-name": "Pfad 779",
    transform: "translate(-810.578 -516.773)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_148",
    "data-name": "Gruppe 148",
    transform: "translate(218.632 109.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_147",
    "data-name": "Gruppe 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_780",
    d: "M855.747 465.31l-.188-2.03 2.277.65-.708 1.724z",
    className: "cls-2",
    "data-name": "Pfad 780",
    transform: "translate(-855.559 -463.28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_150",
    "data-name": "Gruppe 150",
    transform: "translate(239.509 59.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_149",
    "data-name": "Gruppe 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_781",
    d: "M898.435 363.232l3.265-1.951 5.524 1.414-5.209 3.732z",
    className: "cls-2",
    "data-name": "Pfad 781",
    transform: "translate(-898.435 -361.281)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_152",
    "data-name": "Gruppe 152",
    transform: "translate(290.504 124.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_151",
    "data-name": "Gruppe 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_782",
    d: "M1004.125 496.065l-.961-2.639 3.673.153-.558 3.244z",
    className: "cls-2",
    "data-name": "Pfad 782",
    transform: "translate(-1003.164 -493.426)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_154",
    "data-name": "Gruppe 154",
    transform: "translate(288.757 28.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_153",
    "data-name": "Gruppe 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_783",
    d: "M999.575 298.385l1.19-2 1.636 1.471-.99 1.969z",
    className: "cls-2",
    "data-name": "Pfad 783",
    transform: "translate(-999.575 -296.384)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_156",
    "data-name": "Gruppe 156",
    transform: "translate(339.53 18.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_155",
    "data-name": "Gruppe 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_784",
    d: "M1103.849 282.382l.324-5.476 3.84-1.209 1.036 4.246z",
    className: "cls-2",
    "data-name": "Pfad 784",
    transform: "translate(-1103.849 -275.698)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_158",
    "data-name": "Gruppe 158",
    transform: "translate(346.745 37.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_157",
    "data-name": "Gruppe 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_785",
    d: "M1118.668 317.821l2.231-1.533 2.922 1.787-3.108 2z",
    className: "cls-2",
    "data-name": "Pfad 785",
    transform: "translate(-1118.668 -316.287)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_160",
    "data-name": "Gruppe 160",
    transform: "translate(393.907 26.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_159",
    "data-name": "Gruppe 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_786",
    d: "M1215.524 297.112l1.695-4.362 3.1 2.619-.5 4.537z",
    className: "cls-2",
    "data-name": "Pfad 786",
    transform: "translate(-1215.524 -292.75)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_162",
    "data-name": "Gruppe 162",
    transform: "translate(446.764 27.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_161",
    "data-name": "Gruppe 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_787",
    d: "M1324.769 296.187l-.689-1.8 2.256.1.092 2.062z",
    className: "cls-2",
    "data-name": "Pfad 787",
    transform: "translate(-1324.08 -294.384)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_164",
    "data-name": "Gruppe 164",
    transform: "translate(502.575 80.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_163",
    "data-name": "Gruppe 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_788",
    d: "M1438.7 406.922l2.506-3.825 3.065 2.385-1.245 4.652z",
    className: "cls-2",
    "data-name": "Pfad 788",
    transform: "translate(-1438.7 -403.097)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_166",
    "data-name": "Gruppe 166",
    transform: "translate(507.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_165",
    "data-name": "Gruppe 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_789",
    d: "M1449.645 241.031l1.794-2.515 3.217 1.647-2.2 4.225z",
    className: "cls-2",
    "data-name": "Pfad 789",
    transform: "translate(-1449.645 -238.516)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_168",
    "data-name": "Gruppe 168",
    transform: "translate(554.701 117.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_167",
    "data-name": "Gruppe 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_790",
    d: "M1545.752 481.077l.922-1.463 1.462.137-.422 1.73z",
    className: "cls-2",
    "data-name": "Pfad 790",
    transform: "translate(-1545.752 -479.614)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_170",
    "data-name": "Gruppe 170",
    transform: "translate(589.259 10.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_169",
    "data-name": "Gruppe 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_791",
    d: "M1616.725 266.154l2.646-5.384 4.173 4.753-3.255 5.165z",
    className: "cls-2",
    "data-name": "Pfad 791",
    transform: "translate(-1616.725 -260.77)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_214",
    "data-name": "Gruppe 214",
    transform: "translate(35.048 26.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_173",
    "data-name": "Gruppe 173",
    transform: "translate(0 85.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_172",
    "data-name": "Gruppe 172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_792",
    d: "M255.6 368.246l6.015-.758.916 6.195-6.7 1.177z",
    className: "cls-3",
    "data-name": "Pfad 792",
    transform: "translate(-255.597 -367.488)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_175",
    "data-name": "Gruppe 175",
    transform: "translate(58.181 7.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_174",
    "data-name": "Gruppe 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_793",
    d: "M376.106 207.759l3.909 1.018-1.037 3.183-3.894.188z",
    className: "cls-3",
    "data-name": "Pfad 793",
    transform: "translate(-375.084 -207.759)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_177",
    "data-name": "Gruppe 177",
    transform: "translate(104.756 6.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_176",
    "data-name": "Gruppe 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_794",
    d: "M470.738 206.742l3.128-1.686 1.933 3.321-3.313.95z",
    className: "cls-3",
    "data-name": "Pfad 794",
    transform: "translate(-470.738 -205.055)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_179",
    "data-name": "Gruppe 179",
    transform: "translate(153.638 67.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_178",
    "data-name": "Gruppe 178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_795",
    d: "M571.129 333.09l.714-1.84 1.812 1.328-1.218 1.6z",
    className: "cls-3",
    "data-name": "Pfad 795",
    transform: "translate(-571.129 -331.25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_181",
    "data-name": "Gruppe 181",
    transform: "translate(174.058 27.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_180",
    "data-name": "Gruppe 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_796",
    d: "M613.684 248.05l.514.292-.167.673-.966-.266z",
    className: "cls-3",
    "data-name": "Pfad 796",
    transform: "translate(-613.065 -248.05)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_183",
    "data-name": "Gruppe 183",
    transform: "translate(227.478 .387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_182",
    "data-name": "Gruppe 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_797",
    d: "M722.776 195.438l3.071-2.668 4.508 3.634-5.135 1.283z",
    className: "cls-3",
    "data-name": "Pfad 797",
    transform: "translate(-722.776 -192.77)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_185",
    "data-name": "Gruppe 185",
    transform: "translate(262.911 8.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_184",
    "data-name": "Gruppe 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_798",
    d: "M795.544 209.69l4.7 2.122-.686 3.488-3.2-.71z",
    className: "cls-3",
    "data-name": "Pfad 798",
    transform: "translate(-795.544 -209.69)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_187",
    "data-name": "Gruppe 187",
    transform: "translate(277.887 52.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_186",
    "data-name": "Gruppe 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_799",
    d: "M826.3 301.424l.2-1.388.939-.142.555 1.252z",
    className: "cls-3",
    "data-name": "Pfad 799",
    transform: "translate(-826.301 -299.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_189",
    "data-name": "Gruppe 189",
    transform: "translate(309.157 124.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_188",
    "data-name": "Gruppe 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_800",
    d: "M890.521 447.895l3.311.8.456 2.755-2.32-.782z",
    className: "cls-3",
    "data-name": "Pfad 800",
    transform: "translate(-890.521 -447.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_191",
    "data-name": "Gruppe 191",
    transform: "translate(361.257 46.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_190",
    "data-name": "Gruppe 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_801",
    d: "M997.52 291.022l.218-3.366 3.187.812-.573 2.673z",
    className: "cls-3",
    "data-name": "Pfad 801",
    transform: "translate(-997.52 -287.656)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_193",
    "data-name": "Gruppe 193",
    transform: "translate(371.786 82.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_192",
    "data-name": "Gruppe 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_802",
    d: "M1019.144 362.382l1-1.206.446 1.515-1.082 1.458z",
    className: "cls-3",
    "data-name": "Pfad 802",
    transform: "translate(-1019.144 -361.176)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_195",
    "data-name": "Gruppe 195",
    transform: "translate(399.411 122.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_194",
    "data-name": "Gruppe 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_803",
    d: "M1075.879 445.5V443l2.3.328-.284 1.815z",
    className: "cls-3",
    "data-name": "Pfad 803",
    transform: "translate(-1075.879 -443.005)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_197",
    "data-name": "Gruppe 197",
    transform: "translate(413.738 88.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_196",
    "data-name": "Gruppe 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_804",
    d: "M1105.579 377.072l-.277-3.1 4.405.149-1.118 4.444z",
    className: "cls-3",
    "data-name": "Pfad 804",
    transform: "translate(-1105.302 -373.968)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_199",
    "data-name": "Gruppe 199",
    transform: "translate(440.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_198",
    "data-name": "Gruppe 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_805",
    d: "M1160.868 194.7l2.232-2.722 1.672 1.966-.892 2.066z",
    className: "cls-3",
    "data-name": "Pfad 805",
    transform: "translate(-1160.868 -191.975)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_201",
    "data-name": "Gruppe 201",
    transform: "translate(501.485 55.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_200",
    "data-name": "Gruppe 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_806",
    d: "M1285.51 306.785l.393-.7 1.014.635-.964.406z",
    className: "cls-3",
    "data-name": "Pfad 806",
    transform: "translate(-1285.51 -306.083)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_203",
    "data-name": "Gruppe 203",
    transform: "translate(537.211 11.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_202",
    "data-name": "Gruppe 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_807",
    d: "M1359.106 216.02l2.525.121-1.273 2.6-1.477-1.342z",
    className: "cls-3",
    "data-name": "Pfad 807",
    transform: "translate(-1358.881 -216.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_205",
    "data-name": "Gruppe 205",
    transform: "translate(547.775 85.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_204",
    "data-name": "Gruppe 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_808",
    d: "M1381.818 370.863l-1.24-3.413 3.275-.171 1.247 2.738z",
    className: "cls-3",
    "data-name": "Pfad 808",
    transform: "translate(-1380.578 -367.279)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_207",
    "data-name": "Gruppe 207",
    transform: "translate(607.388 56.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_206",
    "data-name": "Gruppe 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_809",
    d: "M1503.113 311.741l-.107-3.02 2.689-1.239.756 3.326z",
    className: "cls-3",
    "data-name": "Pfad 809",
    transform: "translate(-1503.006 -307.482)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_209",
    "data-name": "Gruppe 209",
    transform: "translate(664.357 56.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_208",
    "data-name": "Gruppe 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_810",
    d: "M1620.006 308.58l2.162-1.43-.2 2.73-1.573-.053z",
    className: "cls-3",
    "data-name": "Pfad 810",
    transform: "translate(-1620.006 -307.15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_211",
    "data-name": "Gruppe 211",
    transform: "translate(664.462 38.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_210",
    "data-name": "Gruppe 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_811",
    d: "M1620.442 270.333l4.848 1.2-2.25 4.364-2.817-2z",
    className: "cls-3",
    "data-name": "Pfad 811",
    transform: "translate(-1620.222 -270.333)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_213",
    "data-name": "Gruppe 213",
    transform: "translate(716.796 115.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_212",
    "data-name": "Gruppe 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_812",
    d: "M1727.7 431.6l4.21-1.637 2.645 1.41-2.52 2.355z",
    className: "cls-3",
    "data-name": "Pfad 812",
    transform: "translate(-1727.701 -429.962)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_269",
    "data-name": "Gruppe 269",
    transform: "translate(12.602 8.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_216",
    "data-name": "Gruppe 216",
    transform: "translate(0 39.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_215",
    "data-name": "Gruppe 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_813",
    d: "M211.55 235.772l5.141 2.5-2.372 3.617-4.821-.361z",
    className: "cls-4",
    "data-name": "Pfad 813",
    transform: "translate(-209.498 -235.772)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_218",
    "data-name": "Gruppe 218",
    transform: "translate(58.295 62.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_217",
    "data-name": "Gruppe 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_814",
    d: "M330.548 283.693l2.277.247.283 2.129-3.887 1.755z",
    className: "cls-4",
    "data-name": "Pfad 814",
    transform: "translate(-329.221 -283.693)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_220",
    "data-name": "Gruppe 220",
    transform: "translate(66.715 71.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_219",
    "data-name": "Gruppe 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_815",
    d: "M348.035 302.245l1.793.273-.18 2.82-3.136-1.09z",
    className: "cls-4",
    "data-name": "Pfad 815",
    transform: "translate(-346.513 -302.245)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_222",
    "data-name": "Gruppe 222",
    transform: "translate(70.602 152.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_221",
    "data-name": "Gruppe 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_816",
    d: "M354.5 468.9l2.286.219.648 1.534-1.706.238z",
    className: "cls-4",
    "data-name": "Pfad 816",
    transform: "translate(-354.496 -468.904)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_224",
    "data-name": "Gruppe 224",
    transform: "translate(108.97 53.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_223",
    "data-name": "Gruppe 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_817",
    d: "M433.567 271.121l-.273-4.673 4.185-.95-.01 3.855z",
    className: "cls-4",
    "data-name": "Pfad 817",
    transform: "translate(-433.293 -265.498)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_226",
    "data-name": "Gruppe 226",
    transform: "translate(137.309 79.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_225",
    "data-name": "Gruppe 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_818",
    d: "M491.494 318.372l1.473-.212.531 1.376-1.261-.119z",
    className: "cls-4",
    "data-name": "Pfad 818",
    transform: "translate(-491.494 -318.16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_228",
    "data-name": "Gruppe 228",
    transform: "translate(190.911 45.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_227",
    "data-name": "Gruppe 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_819",
    d: "M601.687 249.687l1.429-1.212.68 2.407-2.218.309z",
    className: "cls-4",
    "data-name": "Pfad 819",
    transform: "translate(-601.578 -248.475)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_230",
    "data-name": "Gruppe 230",
    transform: "translate(211.77 29.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_229",
    "data-name": "Gruppe 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_820",
    d: "M644.472 217.43l-.056-.769.928-.283.26 1.268z",
    className: "cls-4",
    "data-name": "Pfad 820",
    transform: "translate(-644.416 -216.378)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_232",
    "data-name": "Gruppe 232",
    transform: "translate(239.932 151.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_231",
    "data-name": "Gruppe 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_821",
    d: "M702.253 468.136l.115-1.206 2.033-.455-.561 2.359z",
    className: "cls-4",
    "data-name": "Pfad 821",
    transform: "translate(-702.253 -466.475)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_234",
    "data-name": "Gruppe 234",
    transform: "translate(265.475 106.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_233",
    "data-name": "Gruppe 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_822",
    d: "M755.329 374.718l1.065-.111-.015 1.26-1.668.279z",
    className: "cls-4",
    "data-name": "Pfad 822",
    transform: "translate(-754.711 -374.608)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_236",
    "data-name": "Gruppe 236",
    transform: "translate(281.709 73.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_235",
    "data-name": "Gruppe 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_823",
    d: "M788.075 307.361l1.868-.927 1.2 2-3.094 3.392z",
    className: "cls-4",
    "data-name": "Pfad 823",
    transform: "translate(-788.052 -306.433)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_238",
    "data-name": "Gruppe 238",
    transform: "translate(305.542 81.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_237",
    "data-name": "Gruppe 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_824",
    d: "M837 325.218l2.344-1.841 2.877 1.781-2.812 3.79z",
    className: "cls-4",
    "data-name": "Pfad 824",
    transform: "translate(-836.999 -323.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_240",
    "data-name": "Gruppe 240",
    transform: "translate(326.91 156.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_239",
    "data-name": "Gruppe 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_825",
    d: "M880.883 476.337l.647-.453.608.4-.553 1z",
    className: "cls-4",
    "data-name": "Pfad 825",
    transform: "translate(-880.883 -475.884)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_242",
    "data-name": "Gruppe 242",
    transform: "translate(370.973 29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_241",
    "data-name": "Gruppe 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_826",
    d: "M971.377 217.085l1.706-2.046 3.511-.041-2.068 3.649z",
    className: "cls-4",
    "data-name": "Pfad 826",
    transform: "translate(-971.377 -214.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_244",
    "data-name": "Gruppe 244",
    transform: "translate(393.902 77.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_243",
    "data-name": "Gruppe 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_827",
    d: "M1019.373 315.321l1.457 1.386-.415 1.737-1.949-.948z",
    className: "cls-4",
    "data-name": "Pfad 827",
    transform: "translate(-1018.465 -315.321)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_246",
    "data-name": "Gruppe 246",
    transform: "translate(413.834 44.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_245",
    "data-name": "Gruppe 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_828",
    d: "M1059.4 251.777l1.188-4.257 2.981 2.965-1.222 2.714z",
    className: "cls-4",
    "data-name": "Pfad 828",
    transform: "translate(-1059.401 -247.521)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_248",
    "data-name": "Gruppe 248",
    transform: "translate(435.126 148.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_247",
    "data-name": "Gruppe 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_829",
    d: "M1103.128 461.1l3.334-1.436 2.065 1.366-2.027 1.524z",
    className: "cls-4",
    "data-name": "Pfad 829",
    transform: "translate(-1103.128 -459.668)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_250",
    "data-name": "Gruppe 250",
    transform: "translate(470.835 90.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_249",
    "data-name": "Gruppe 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_830",
    d: "M1176.465 344.531l2.118-2.209 1.921 2.739-2.6 2.466z",
    className: "cls-4",
    "data-name": "Pfad 830",
    transform: "translate(-1176.465 -342.322)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_252",
    "data-name": "Gruppe 252",
    transform: "translate(504.86 69.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_251",
    "data-name": "Gruppe 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_831",
    d: "M1246.344 300.285l4.239-2.04 1.308 3.233-2.532 2.456z",
    className: "cls-4",
    "data-name": "Pfad 831",
    transform: "translate(-1246.344 -298.245)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_254",
    "data-name": "Gruppe 254",
    transform: "translate(562.895 134.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_253",
    "data-name": "Gruppe 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_832",
    d: "M1365.658 433.04l-.127-1.791 2.049-.018-.7 1.451z",
    className: "cls-4",
    "data-name": "Pfad 832",
    transform: "translate(-1365.531 -431.232)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_256",
    "data-name": "Gruppe 256",
    transform: "translate(571.526 134.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_255",
    "data-name": "Gruppe 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_833",
    d: "M1383.473 431.385l1.24-.565-.421 1.265-1.036.439z",
    className: "cls-4",
    "data-name": "Pfad 833",
    transform: "translate(-1383.256 -430.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_258",
    "data-name": "Gruppe 258",
    transform: "translate(571.882 98.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_257",
    "data-name": "Gruppe 257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_834",
    d: "M1383.988 360.659l2.952-2.293 2.657 1.915-2.2 4.89z",
    className: "cls-4",
    "data-name": "Pfad 834",
    transform: "translate(-1383.988 -358.366)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_260",
    "data-name": "Gruppe 260",
    transform: "translate(595.433 125.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_259",
    "data-name": "Gruppe 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_835",
    d: "M1432.355 413.393l4.413-1.059 3.131 1.92-3.74 3.418z",
    className: "cls-4",
    "data-name": "Pfad 835",
    transform: "translate(-1432.355 -412.333)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_262",
    "data-name": "Gruppe 262",
    transform: "translate(647.047 123.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_261",
    "data-name": "Gruppe 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_836",
    d: "M1538.356 411.824l.116-2.364 4.007-.453-1.469 4.167z",
    className: "cls-4",
    "data-name": "Pfad 836",
    transform: "translate(-1538.356 -409.007)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_264",
    "data-name": "Gruppe 264",
    transform: "translate(664.966 133.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_263",
    "data-name": "Gruppe 263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_837",
    d: "M1576.238 430.512l3.258-.081 3.4 5.043-7.741.781z",
    className: "cls-4",
    "data-name": "Pfad 837",
    transform: "translate(-1575.156 -430.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_266",
    "data-name": "Gruppe 266",
    transform: "translate(711.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_265",
    "data-name": "Gruppe 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_838",
    d: "M1671.431 159.344l3.41-3.9 1.994 4.112-2.253 2.643z",
    className: "cls-4",
    "data-name": "Pfad 838",
    transform: "translate(-1671.431 -155.44)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_268",
    "data-name": "Gruppe 268",
    transform: "translate(747.925 129.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_267",
    "data-name": "Gruppe 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_839",
    d: "M1746.79 426.35l-1.257-3.935 3.9.884 1.5 3.79z",
    className: "cls-4",
    "data-name": "Pfad 839",
    transform: "translate(-1745.533 -422.415)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_320",
    "data-name": "Gruppe 320",
    transform: "translate(0 37.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_271",
    "data-name": "Gruppe 271",
    transform: "translate(0 98.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_270",
    "data-name": "Gruppe 270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_840",
    d: "M183.618 419.187l1.811-.953.106 1.539-.97 1.29z",
    className: "cls-5",
    "data-name": "Pfad 840",
    transform: "translate(-183.618 -418.234)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_273",
    "data-name": "Gruppe 273",
    transform: "translate(28.365 99.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_272",
    "data-name": "Gruppe 272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_841",
    d: "M242.941 428.036l-1.069-6.892 5.521 2.122 2.48 5.344z",
    className: "cls-5",
    "data-name": "Pfad 841",
    transform: "translate(-241.872 -421.144)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_275",
    "data-name": "Gruppe 275",
    transform: "translate(37.614 81.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_274",
    "data-name": "Gruppe 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_842",
    d: "M260.977 384.968l-.11-1.819 2.179-.071-.593 1.807z",
    className: "cls-5",
    "data-name": "Pfad 842",
    transform: "translate(-260.867 -383.078)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_277",
    "data-name": "Gruppe 277",
    transform: "translate(56.146 57.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_276",
    "data-name": "Gruppe 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_843",
    d: "M298.926 337.118l3.564-3.3 4.531.892-2.961 4.39z",
    className: "cls-5",
    "data-name": "Pfad 843",
    transform: "translate(-298.926 -333.819)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_279",
    "data-name": "Gruppe 279",
    transform: "translate(83.227 94.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_278",
    "data-name": "Gruppe 278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_844",
    d: "M354.543 410.646l1.838-.3-.232 1.929-1.218-.5z",
    className: "cls-5",
    "data-name": "Pfad 844",
    transform: "translate(-354.543 -410.349)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_281",
    "data-name": "Gruppe 281",
    transform: "translate(109.966 16.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_280",
    "data-name": "Gruppe 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_845",
    d: "M409.564 251.208l3.156-1.318-.42 3.31-2.843 1.187z",
    className: "cls-5",
    "data-name": "Pfad 845",
    transform: "translate(-409.459 -249.89)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_283",
    "data-name": "Gruppe 283",
    transform: "translate(148.222 115.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_282",
    "data-name": "Gruppe 282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_846",
    d: "M488.027 454.207l.566-.045.266.828-.786-.277z",
    className: "cls-5",
    "data-name": "Pfad 846",
    transform: "translate(-488.027 -454.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_285",
    "data-name": "Gruppe 285",
    transform: "translate(187.276 30.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_284",
    "data-name": "Gruppe 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_847",
    d: "M568.232 281.244l1.6-2.584 2.606.685-.684 3.573z",
    className: "cls-5",
    "data-name": "Pfad 847",
    transform: "translate(-568.232 -278.66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_287",
    "data-name": "Gruppe 287",
    transform: "translate(199.352 103.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_286",
    "data-name": "Gruppe 286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_848",
    d: "M593.032 427.677l3.932.211.992 4.453-4.03-1.247z",
    className: "cls-5",
    "data-name": "Pfad 848",
    transform: "translate(-593.032 -427.677)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_289",
    "data-name": "Gruppe 289",
    transform: "translate(239.058 123.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_288",
    "data-name": "Gruppe 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_849",
    d: "M674.577 470.485l1.154-.987 1.294.282-.919 1.019z",
    className: "cls-5",
    "data-name": "Pfad 849",
    transform: "translate(-674.577 -469.497)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_291",
    "data-name": "Gruppe 291",
    transform: "translate(289.245 58.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_290",
    "data-name": "Gruppe 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_850",
    d: "M777.711 338.292l-.062-2.156 2.338.559-.521 2.029z",
    className: "cls-5",
    "data-name": "Pfad 850",
    transform: "translate(-777.649 -336.136)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_293",
    "data-name": "Gruppe 293",
    transform: "translate(314.883 21.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_292",
    "data-name": "Gruppe 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_851",
    d: "M830.3 261.433l1.646-1.689 1.089 1.594-.947 2.461z",
    className: "cls-5",
    "data-name": "Pfad 851",
    transform: "translate(-830.302 -259.744)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_295",
    "data-name": "Gruppe 295",
    transform: "translate(360.905 94.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_294",
    "data-name": "Gruppe 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_852",
    d: "M924.818 410.429l1-.021.113.79-.708.07z",
    className: "cls-5",
    "data-name": "Pfad 852",
    transform: "translate(-924.818 -410.408)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_297",
    "data-name": "Gruppe 297",
    transform: "translate(393.95 14.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_296",
    "data-name": "Gruppe 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_853",
    d: "M992.684 247.721l4.164-1.916.459 3.46-2.5 2.651z",
    className: "cls-5",
    "data-name": "Pfad 853",
    transform: "translate(-992.684 -245.804)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_299",
    "data-name": "Gruppe 299",
    transform: "translate(449.379 99.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_298",
    "data-name": "Gruppe 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_854",
    d: "M1106.52 421.064l6.028 1.982.967 5.671-5.227-1.776z",
    className: "cls-5",
    "data-name": "Pfad 854",
    transform: "translate(-1106.52 -421.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_301",
    "data-name": "Gruppe 301",
    transform: "translate(464.883 90.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_300",
    "data-name": "Gruppe 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_855",
    d: "M1138.361 403.663l1.665-1.351.394 1.712-.984 1.65z",
    className: "cls-5",
    "data-name": "Pfad 855",
    transform: "translate(-1138.361 -402.313)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_303",
    "data-name": "Gruppe 303",
    transform: "translate(498.764 16.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_302",
    "data-name": "Gruppe 302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_856",
    d: "M1209.372 254.583l-1.428-4.152 3.891.676 2.091 3.561z",
    className: "cls-5",
    "data-name": "Pfad 856",
    transform: "translate(-1207.944 -250.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_305",
    "data-name": "Gruppe 305",
    transform: "translate(533.516 51.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_304",
    "data-name": "Gruppe 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_857",
    d: "M1279.315 323.247l.54-2.054 1.8.326-.333 1.654z",
    className: "cls-5",
    "data-name": "Pfad 857",
    transform: "translate(-1279.315 -321.193)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_307",
    "data-name": "Gruppe 307",
    transform: "translate(548.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_306",
    "data-name": "Gruppe 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_858",
    d: "M1309.074 219.07l3.831-3.118 1.888 2.957-1.7 3.827z",
    className: "cls-5",
    "data-name": "Pfad 858",
    transform: "translate(-1309.074 -215.952)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_309",
    "data-name": "Gruppe 309",
    transform: "translate(578.652 110.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_308",
    "data-name": "Gruppe 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_859",
    d: "M1372.534 447.209l-.522-3.678 3.241-1.117.925 3.48z",
    className: "cls-5",
    "data-name": "Pfad 859",
    transform: "translate(-1372.012 -442.413)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_311",
    "data-name": "Gruppe 311",
    transform: "translate(617.575 60.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_310",
    "data-name": "Gruppe 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_860",
    d: "M1453.122 340.623l1.433.216-.7 1.411-1.9-.241z",
    className: "cls-5",
    "data-name": "Pfad 860",
    transform: "translate(-1451.95 -340.623)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_313",
    "data-name": "Gruppe 313",
    transform: "translate(643.612 8.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_312",
    "data-name": "Gruppe 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_861",
    d: "M1506.386 233.519l1.145-.041-.764.94-1.344-.046z",
    className: "cls-5",
    "data-name": "Pfad 861",
    transform: "translate(-1505.422 -233.478)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_315",
    "data-name": "Gruppe 315",
    transform: "translate(683.51 38.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_314",
    "data-name": "Gruppe 314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_862",
    d: "M1587.363 301.108l1.563-5.484 3.105 4.206-.612 4.9z",
    className: "cls-5",
    "data-name": "Pfad 862",
    transform: "translate(-1587.363 -295.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_317",
    "data-name": "Gruppe 317",
    transform: "translate(726.656 4.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_316",
    "data-name": "Gruppe 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_863",
    d: "M1675.972 225.545l1.466-.247.432 1.26-1.492.728z",
    className: "cls-5",
    "data-name": "Pfad 863",
    transform: "translate(-1675.972 -225.298)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_319",
    "data-name": "Gruppe 319",
    transform: "translate(769.866 85.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_318",
    "data-name": "Gruppe 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_864",
    d: "M1764.713 391.571l4.585-.62.153 3.357-3.921 3.164z",
    className: "cls-5",
    "data-name": "Pfad 864",
    transform: "translate(-1764.713 -390.951)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_363",
    "data-name": "Gruppe 363",
    transform: "translate(32.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_322",
    "data-name": "Gruppe 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_321",
    "data-name": "Gruppe 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_865",
    d: "M250.879 138.845l3.687-.441 2.183 3.707-4.185-.11z",
    className: "cls-6",
    "data-name": "Pfad 865",
    transform: "translate(-250.879 -138.404)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_324",
    "data-name": "Gruppe 324",
    transform: "translate(59.309 6.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_323",
    "data-name": "Gruppe 323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_866",
    d: "M372.683 155.023l2.819-3.279 2.582.69-.027 4.641z",
    className: "cls-6",
    "data-name": "Pfad 866",
    transform: "translate(-372.683 -151.744)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_326",
    "data-name": "Gruppe 326",
    transform: "translate(94.836 47.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_325",
    "data-name": "Gruppe 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_867",
    d: "M446.1 235.759l4.951-.694-1.051 5.01-4.349-.13z",
    className: "cls-6",
    "data-name": "Pfad 867",
    transform: "translate(-445.646 -235.065)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_328",
    "data-name": "Gruppe 328",
    transform: "translate(158.449 16.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_327",
    "data-name": "Gruppe 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_868",
    d: "M576.782 171.267l4.8 2.844-2.792 3.768-2.5-2.166z",
    className: "cls-6",
    "data-name": "Pfad 868",
    transform: "translate(-576.29 -171.267)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_330",
    "data-name": "Gruppe 330",
    transform: "translate(162.255 43.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_329",
    "data-name": "Gruppe 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_869",
    d: "M584.105 228.486l.507-1.13 1.6.618-1.172 1.122z",
    className: "cls-6",
    "data-name": "Pfad 869",
    transform: "translate(-584.105 -227.357)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_332",
    "data-name": "Gruppe 332",
    transform: "translate(217.554 63.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_331",
    "data-name": "Gruppe 331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_870",
    d: "M697.675 272.061l1.365-3.035 1.868 1.445-.347 1.648z",
    className: "cls-6",
    "data-name": "Pfad 870",
    transform: "translate(-697.675 -269.026)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_334",
    "data-name": "Gruppe 334",
    transform: "translate(262.914 105.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_333",
    "data-name": "Gruppe 333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_871",
    d: "M792.02 354.049l1.69 1.725-.193 1.716-2.684-.465z",
    className: "cls-6",
    "data-name": "Pfad 871",
    transform: "translate(-790.833 -354.049)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_336",
    "data-name": "Gruppe 336",
    transform: "translate(287.277 108.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_335",
    "data-name": "Gruppe 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_872",
    d: "M840.867 360.438l3.795 1.673-1.916 2.2-1.71-.445z",
    className: "cls-6",
    "data-name": "Pfad 872",
    transform: "translate(-840.867 -360.438)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_338",
    "data-name": "Gruppe 338",
    transform: "translate(310.254 151.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_337",
    "data-name": "Gruppe 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_873",
    d: "M888.057 453.318l1.449-2.765 2.164 1.361-.317 3.393z",
    className: "cls-6",
    "data-name": "Pfad 873",
    transform: "translate(-888.057 -450.553)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_340",
    "data-name": "Gruppe 340",
    transform: "translate(335.462 127.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_339",
    "data-name": "Gruppe 339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_874",
    d: "M939.827 404.155l1.629-3.307 3.242.648-.76 3.9z",
    className: "cls-6",
    "data-name": "Pfad 874",
    transform: "translate(-939.827 -400.848)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_342",
    "data-name": "Gruppe 342",
    transform: "translate(390.059 105.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_341",
    "data-name": "Gruppe 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_875",
    d: "M1052.316 355.825l3.523 1.069-1.654 2.871-2.232-1.027z",
    className: "cls-6",
    "data-name": "Pfad 875",
    transform: "translate(-1051.953 -355.825)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_344",
    "data-name": "Gruppe 344",
    transform: "translate(393.2 151.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_343",
    "data-name": "Gruppe 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_876",
    d: "M1058.4 453.651l.478-2.941 3.325-.87.542 4.728z",
    className: "cls-6",
    "data-name": "Pfad 876",
    transform: "translate(-1058.404 -449.839)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_346",
    "data-name": "Gruppe 346",
    transform: "translate(431.91 105.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_345",
    "data-name": "Gruppe 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_877",
    d: "M1137.9 357.429l5.857-1.406.649 4.988-5.189 3.256z",
    className: "cls-6",
    "data-name": "Pfad 877",
    transform: "translate(-1137.904 -356.023)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_348",
    "data-name": "Gruppe 348",
    transform: "translate(477.506 162.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_347",
    "data-name": "Gruppe 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_878",
    d: "M1231.546 473.847l.276-1.692 1.412.375.029 1.471z",
    className: "cls-6",
    "data-name": "Pfad 878",
    transform: "translate(-1231.546 -472.155)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_350",
    "data-name": "Gruppe 350",
    transform: "translate(524.084 93.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_349",
    "data-name": "Gruppe 349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_879",
    d: "M1327.2 332.7l.068-2.606h2.3l.884 2.9z",
    className: "cls-6",
    "data-name": "Pfad 879",
    transform: "translate(-1327.204 -330.09)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_352",
    "data-name": "Gruppe 352",
    transform: "translate(570.473 150.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_351",
    "data-name": "Gruppe 351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_880",
    d: "M1422.475 447.814l.986.332-.162.736-.75-.032z",
    className: "cls-6",
    "data-name": "Pfad 880",
    transform: "translate(-1422.475 -447.814)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_354",
    "data-name": "Gruppe 354",
    transform: "translate(591.412 160.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_353",
    "data-name": "Gruppe 353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_881",
    d: "M1465.478 468.539l2.879-1.246.289 2.182-1.319 1.305z",
    className: "cls-6",
    "data-name": "Pfad 881",
    transform: "translate(-1465.478 -467.292)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_356",
    "data-name": "Gruppe 356",
    transform: "translate(643.067 136.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_355",
    "data-name": "Gruppe 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_882",
    d: "M1571.564 420.87l4.943-2.268 2.234 5.4-5.03 1.019z",
    className: "cls-6",
    "data-name": "Pfad 882",
    transform: "translate(-1571.564 -418.602)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_358",
    "data-name": "Gruppe 358",
    transform: "translate(698.708 131.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_357",
    "data-name": "Gruppe 357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_883",
    d: "M1685.834 409.011l.421-.974.642.663-.3.491z",
    className: "cls-6",
    "data-name": "Pfad 883",
    transform: "translate(-1685.834 -408.037)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_360",
    "data-name": "Gruppe 360",
    transform: "translate(717.578 119.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_359",
    "data-name": "Gruppe 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_884",
    d: "M1725.418 384.523l1.327.126.667 2.108-2.824-.183z",
    className: "cls-6",
    "data-name": "Pfad 884",
    transform: "translate(-1724.588 -384.523)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_362",
    "data-name": "Gruppe 362",
    transform: "translate(733.315 85.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_361",
    "data-name": "Gruppe 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_885",
    d: "M1756.907 314.341l.984.183-.013.618-.663.2z",
    className: "cls-6",
    "data-name": "Pfad 885",
    transform: "translate(-1756.907 -314.341)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_886",
    d: "M501.927 391.3l.557-1.733 1.742.164.216 2.7z",
    className: "cls-7",
    "data-name": "Pfad 886",
    transform: "translate(-163.318 -128.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_887",
    d: "M529.935 505.258l.282-4.544 5.2-1.208.18 6.332z",
    className: "cls-8",
    "data-name": "Pfad 887",
    transform: "translate(-177.688 -185.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_888",
    d: "M591.574 500.808l3.149-.5-1.151 2.885-1.93-.3z",
    className: "cls-9",
    "data-name": "Pfad 888",
    transform: "translate(-209.314 -185.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_889",
    d: "M619.964 398.2l3.227.664-.162 3.624-4.051-.614z",
    className: "cls-9",
    "data-name": "Pfad 889",
    transform: "translate(-223.375 -133.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_890",
    d: "M625.178 575.541l2.37.9-.953 2.632-3.237-.95z",
    className: "cls-10",
    "data-name": "Pfad 890",
    transform: "translate(-225.621 -224.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_891",
    d: "M661.647 327.031l-.056-2.859 3.077.68-.616 2.732z",
    className: "cls-7",
    "data-name": "Pfad 891",
    transform: "translate(-245.239 -95.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_892",
    d: "M781.712 471.495l2.994-2.465 4.289.738-3.319 3.351z",
    className: "cls-10",
    "data-name": "Pfad 892",
    transform: "translate(-306.87 -169.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_893",
    d: "M858.957 418.057l1.04-1.737 1.909.935-1.327 1.2z",
    className: "cls-10",
    "data-name": "Pfad 893",
    transform: "translate(-346.503 -142.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_894",
    d: "M930.787 558.073l-.417-3.1 4.744-1.4-1.182 4.822z",
    className: "cls-10",
    "data-name": "Pfad 894",
    transform: "translate(-383.144 -213.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_895",
    d: "M945.526 426.814l2.159-3.853 3.411 1.173-1.566 2.666z",
    className: "cls-8",
    "data-name": "Pfad 895",
    transform: "translate(-390.92 -146.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_896",
    d: "M975.2 586.841l-.5-1.368 1.628-.259.761 1.92z",
    className: "cls-10",
    "data-name": "Pfad 896",
    transform: "translate(-405.89 -229.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_897",
    d: "M1073.838 475.305l2.867-1.623 1.926 1.437-1.795 1.933z",
    className: "cls-10",
    "data-name": "Pfad 897",
    transform: "translate(-456.754 -172.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_898",
    d: "M1165.342 336.569l1.971-2.3 1.917 2.715-2.571 3.376z",
    className: "cls-7",
    "data-name": "Pfad 898",
    transform: "translate(-503.703 -100.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_899",
    d: "M1236.9 388.885l3.451-1.156-.316 3.513-4.066 2.315z",
    className: "cls-10",
    "data-name": "Pfad 899",
    transform: "translate(-539.942 -127.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_900",
    d: "M1261.028 380.12l5.093 1.035-.764 4.527-4.772-.218z",
    className: "cls-8",
    "data-name": "Pfad 900",
    transform: "translate(-552.57 -124.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_901",
    d: "M1320.245 415.3l-.036-.531.736-.143-.183.718z",
    className: "cls-9",
    "data-name": "Pfad 901",
    transform: "translate(-583.163 -141.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_902",
    d: "M1439.726 552.256l2.364.527.879 2.775-3.551-.151z",
    className: "cls-11",
    "data-name": "Pfad 902",
    transform: "translate(-644.326 -212.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_903",
    d: "M1447.7 506.332l1.931-.676.927 2.125-2.159.3z",
    className: "cls-8",
    "data-name": "Pfad 903",
    transform: "translate(-648.576 -188.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_904",
    d: "M1492.082 541.417l.085-.785 1.164.234-.629.98z",
    className: "cls-7",
    "data-name": "Pfad 904",
    transform: "translate(-671.347 -206.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_905",
    d: "M1618.663 372.852l-1.41-2.593 3.748-1.27.04 3.563z",
    className: "cls-7",
    "data-name": "Pfad 905",
    transform: "translate(-735.57 -118.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_906",
    d: "M1625.487 580.209l1.238-.68.7 1.314-1.231.3z",
    className: "cls-10",
    "data-name": "Pfad 906",
    transform: "translate(-739.795 -226.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_907",
    d: "M1624.048 523.09l2.231.808-.494 3.041-4.648-.721z",
    className: "cls-8",
    "data-name": "Pfad 907",
    transform: "translate(-737.563 -197.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_908",
    d: "M1696.963 556.039l2.3-1.245 2.5 1.615-2.871 3.182z",
    className: "cls-10",
    "data-name": "Pfad 908",
    transform: "translate(-776.468 -213.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_909",
    d: "M1715.912 445.368l.339-1.684 1.222.644-.055 1.109z",
    className: "cls-8",
    "data-name": "Pfad 909",
    transform: "translate(-786.19 -156.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_910",
    d: "M1745.452 591.566l3.627-2.728 3.825 1.613-3.152 2.885z",
    className: "cls-9",
    "data-name": "Pfad 910",
    transform: "translate(-801.346 -231.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_911",
    d: "M1556.27 439.91l-.722.923-.728-.726.389-1.762z",
    className: "cls-9",
    "data-name": "Pfad 911",
    transform: "translate(-703.537 -153.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_912",
    d: "M1467.125 529.334l-1.573.428-.523-1 1.257-1.681z",
    className: "cls-11",
    "data-name": "Pfad 912",
    transform: "translate(-657.467 -199.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_913",
    d: "M1429.816 322.216l-.811 2.707-1.677-1.006-.411-2.048z",
    className: "cls-9",
    "data-name": "Pfad 913",
    transform: "translate(-637.912 -94.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_914",
    d: "M1399.151 543.81l.556 1.938-1.98-.761.122-1.488z",
    className: "cls-9",
    "data-name": "Pfad 914",
    transform: "translate(-622.935 -207.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_915",
    d: "M1372.868 332.972l-4.38 2.191-3.242-3.5 4.2-2.081z",
    className: "cls-9",
    "data-name": "Pfad 915",
    transform: "translate(-606.27 -98.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_916",
    d: "M1245.057 369.7l-1.526-.534-.309-2.585 2.019 1.579z",
    className: "cls-10",
    "data-name": "Pfad 916",
    transform: "translate(-543.662 -117.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_917",
    d: "M1218.833 376.073l-1 1.907-1.235-1.5.745-1.213z",
    className: "cls-9",
    "data-name": "Pfad 917",
    transform: "translate(-529.999 -121.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_918",
    d: "M1210.534 357.726l-.8 2.417-1.769-1.324.306-2.114z",
    className: "cls-9",
    "data-name": "Pfad 918",
    transform: "translate(-525.573 -112.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_919",
    d: "M1150.784 544.9l-3.306.314-1.912-2.786 4.009-1.641z",
    className: "cls-9",
    "data-name": "Pfad 919",
    transform: "translate(-493.557 -206.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_920",
    d: "M1107.073 331.006l-.346 1.455-1.779-.052.537-1.827z",
    className: "cls-10",
    "data-name": "Pfad 920",
    transform: "translate(-472.717 -98.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_921",
    d: "M1059.814 430.246l-2.836 2.942-2.89-2.592 2.5-3.728z",
    className: "cls-9",
    "data-name": "Pfad 921",
    transform: "translate(-446.621 -148.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_922",
    d: "M958.363 570.029l.4 3.2-2.508-1.273-.492-2z",
    className: "cls-7",
    "data-name": "Pfad 922",
    transform: "translate(-396.174 -221.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_923",
    d: "M962.73 497.835l-1.646 1.1-1.486-.512 1.171-1.167z",
    className: "cls-9",
    "data-name": "Pfad 923",
    transform: "translate(-398.14 -184.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_924",
    d: "M853.66 512.492l1.943 4.948-6.228 1.93-1.163-6.534z",
    className: "cls-8",
    "data-name": "Pfad 924",
    transform: "translate(-340.99 -191.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_925",
    d: "M841.01 475.467l-3.4 3.94-3.722-4.291 4.115-3.682z",
    className: "cls-10",
    "data-name": "Pfad 925",
    transform: "translate(-333.643 -170.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_926",
    d: "M743.373 494.757l-2.947 5.186-5.551-2.1 3.13-4.566z",
    className: "cls-10",
    "data-name": "Pfad 926",
    transform: "translate(-282.839 -182.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_927",
    d: "M637.453 499.974l-.117 1.792-2.577 1.13.456-3.085z",
    className: "cls-10",
    "data-name": "Pfad 927",
    transform: "translate(-231.471 -185.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_928",
    d: "M520.261 385.693l-2.447 4.6-3.577-3.044 1.816-3.769z",
    className: "cls-9",
    "data-name": "Pfad 928",
    transform: "translate(-169.634 -125.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_929",
    d: "M511.759 553.595l-2.554 1.919-2.137-1.106 1.551-2.278z",
    className: "cls-8",
    "data-name": "Pfad 929",
    transform: "translate(-165.956 -212.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_930",
    d: "M417.057 586.418l-.96 1.978-1.637-.533.152-2.135z",
    className: "cls-10",
    "data-name": "Pfad 930",
    transform: "translate(-118.44 -229.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_931",
    d: "M341.314 525.714l-1.408 4.732-2.724-4.349 2.132-2.043z",
    className: "cls-10",
    "data-name": "Pfad 931",
    transform: "translate(-78.791 -197.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_932",
    d: "M1701.464 423.173l-5.157 2.212 1.635-4.975 3.7-1.826z",
    className: "cls-11",
    "data-name": "Pfad 932",
    transform: "translate(-776.131 -143.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_933",
    d: "M1583.056 584.269l-2.845-.955-.991-4.656 5.742 1.408z",
    className: "cls-7",
    "data-name": "Pfad 933",
    transform: "translate(-716.056 -225.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_934",
    d: "M1489.45 587.953l-2.1 2.784-.06-3.481 1.494-.957z",
    className: "cls-7",
    "data-name": "Pfad 934",
    transform: "translate(-668.89 -229.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_935",
    d: "M1390.7 462.065l-1.484 2.039-3.076-1.113 2.349-2.471z",
    className: "cls-8",
    "data-name": "Pfad 935",
    transform: "translate(-616.991 -165.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_936",
    d: "M1349.865 550.474l-1.083-.557.614-.749.489.353z",
    className: "cls-11",
    "data-name": "Pfad 936",
    transform: "translate(-597.823 -210.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_937",
    d: "M1239.358 598.525l-5.128 1.445-1.871-2.337 2.4-1.805z",
    className: "cls-7",
    "data-name": "Pfad 937",
    transform: "translate(-538.088 -234.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_938",
    d: "M1163.345 580.764l-3.7-1.468-.871-4.921 5.622 1.522z",
    className: "cls-8",
    "data-name": "Pfad 938",
    transform: "translate(-500.334 -223.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_939",
    d: "M1137.115 496.417l.5 1.6-1.755.082.057-1.344z",
    className: "cls-9",
    "data-name": "Pfad 939",
    transform: "translate(-488.579 -183.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_940",
    d: "M1070.351 346.592l-2.274-.21-.033-1.969 2.454-.594z",
    className: "cls-8",
    "data-name": "Pfad 940",
    transform: "translate(-453.781 -105.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_941",
    d: "M964.44 502.239l-1.506 3.638-2.772-.43-.5-3.937z",
    className: "cls-9",
    "data-name": "Pfad 941",
    transform: "translate(-398.171 -186.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_942",
    d: "M944.418 434.524l-2.237 1.017-1.545-1.826 2.048-.527z",
    className: "cls-10",
    "data-name": "Pfad 942",
    transform: "translate(-388.411 -151.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_943",
    d: "M886.47 351.556l-.19 1.634-1.719.162.341-1.627z",
    className: "cls-8",
    "data-name": "Pfad 943",
    transform: "translate(-359.64 -109.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_944",
    d: "M855.2 416.686l-.187 3.765-4.788-.2 1.342-4.611z",
    className: "cls-10",
    "data-name": "Pfad 944",
    transform: "translate(-342.02 -142.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_945",
    d: "M798.35 600.5l-.993 2.483-2.115-1.881 1.363-2z",
    className: "cls-9",
    "data-name": "Pfad 945",
    transform: "translate(-313.812 -236.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_946",
    d: "M679.209 490.348l-.935.824-.432-.759.342-1.13z",
    className: "cls-9",
    "data-name": "Pfad 946",
    transform: "translate(-253.577 -180.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_947",
    d: "M603.985 580.247l-1.464-.4.41-1.9 2.635.5z",
    className: "cls-8",
    "data-name": "Pfad 947",
    transform: "translate(-214.931 -225.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_948",
    d: "M578.209 425.761l2.157 3.062-4.942 1.844.042-4.626z",
    className: "cls-10",
    "data-name": "Pfad 948",
    transform: "translate(-201.028 -147.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_949",
    d: "M458.984 484.1l-.1 2.042-1.32.3-.526-1.422z",
    className: "cls-11",
    "data-name": "Pfad 949",
    transform: "translate(-140.285 -177.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_950",
    d: "M343.1 486.925l-2.891 1.192-.141-3.2 2.743-.715z",
    className: "cls-8",
    "data-name": "Pfad 950",
    transform: "translate(-80.272 -177.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_951",
    d: "M340.778 521.619l-3.548-2 .259-5.043 3.5 3.289z",
    className: "cls-8",
    "data-name": "Pfad 951",
    transform: "translate(-78.815 -193.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_952",
    d: "M228.221 361.8l-2.68 2.087-3.021-1.9 2.825-4.014z",
    className: "cls-8",
    "data-name": "Pfad 952",
    transform: "translate(-19.96 -112.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_953",
    d: "M1746.637 554.143l-4.055-2.454.526-5.341 5.959 2.406z",
    className: "cls-11",
    "data-name": "Pfad 953",
    transform: "translate(-799.874 -209.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_954",
    d: "M1631.391 513.777l-4.266-1.219-.374-3.087 2.646.638z",
    className: "cls-8",
    "data-name": "Pfad 954",
    transform: "translate(-740.443 -190.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_955",
    d: "M1613.563 493.812l-2.052-.526.262-2.906 2.5 1.466z",
    className: "cls-10",
    "data-name": "Pfad 955",
    transform: "translate(-732.623 -180.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_956",
    d: "M1606.556 327.345l-2.467.515-.945-2.553 2.707-.4z",
    className: "cls-11",
    "data-name": "Pfad 956",
    transform: "translate(-728.331 -95.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_957",
    d: "M1525.907 522.962l.557 4.175-3.726.381-1.2-3.809z",
    className: "cls-7",
    "data-name": "Pfad 957",
    transform: "translate(-686.46 -197.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_958",
    d: "M1471.785 479.062l-1.83.175-.39-1.464 1.444-.35z",
    className: "cls-11",
    "data-name": "Pfad 958",
    transform: "translate(-659.794 -173.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_959",
    d: "M1362.037 546.549l-1.609.964.041-1.852 1.48-.834z",
    className: "cls-10",
    "data-name": "Pfad 959",
    transform: "translate(-603.798 -208.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_960",
    d: "M1319.5 580.762l.276.727-1.019.169.121-.913z",
    className: "cls-9",
    "data-name": "Pfad 960",
    transform: "translate(-582.416 -226.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_961",
    d: "M1261.115 327.925l-.587 1.918-2.243.27.6-2.4z",
    className: "cls-8",
    "data-name": "Pfad 961",
    transform: "translate(-551.391 -97.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_962",
    d: "M1207.494 422.678l-1.5.492.49-1.592 1.655-.369z",
    className: "cls-9",
    "data-name": "Pfad 962",
    transform: "translate(-524.563 -145.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_963",
    d: "M1175.34 487.414l-4.854.71-1.978-3.1 3.976-2.6z",
    className: "cls-10",
    "data-name": "Pfad 963",
    transform: "translate(-505.327 -176.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_964",
    d: "M1123.2 469.185l-3.824 2.226-3.663-2.139 3.608-2.619z",
    className: "cls-10",
    "data-name": "Pfad 964",
    transform: "translate(-478.238 -168.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_965",
    d: "M1082.919 592.589l-.865.919-.766-.854.706-.658z",
    className: "cls-10",
    "data-name": "Pfad 965",
    transform: "translate(-460.577 -232.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_966",
    d: "M987.165 578.761l-.419 2.9-4.156-1.068 2.362-3.416z",
    className: "cls-8",
    "data-name": "Pfad 966",
    transform: "translate(-409.937 -225.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_967",
    d: "M943.09 480.662l-1.535-1.36.565-1.547 1.487.862z",
    className: "cls-8",
    "data-name": "Pfad 967",
    transform: "translate(-388.883 -174.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_968",
    d: "M902.981 539.887l-2.432 4.743-2.567-3.195.484-3.529z",
    className: "cls-9",
    "data-name": "Pfad 968",
    transform: "translate(-366.526 -204.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_969",
    d: "M852.8 335.074l-1.28 1.118-3.354-1.058 3.322-1.4z",
    className: "cls-7",
    "data-name": "Pfad 969",
    transform: "translate(-340.966 -100.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_970",
    d: "M785.935 448.917l-4.279 3.363-2.073-4.2 2.988-2.775z",
    className: "cls-11",
    "data-name": "Pfad 970",
    transform: "translate(-305.778 -157.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_971",
    d: "M711.35 492.67l-2.723 1.589-1.6-2.519 2.627-2.243z",
    className: "cls-10",
    "data-name": "Pfad 971",
    transform: "translate(-268.549 -180.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_972",
    d: "M597.182 364.161l.016 1.61-1.913.176.667-1.5z",
    className: "cls-9",
    "data-name": "Pfad 972",
    transform: "translate(-211.218 -115.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_973",
    d: "M580.219 366.112l-.881.3-.03-1.077.939.014z",
    className: "cls-9",
    "data-name": "Pfad 973",
    transform: "translate(-203.021 -116.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_974",
    d: "M574.948 433.073l-1.724 2.845-1.754-2.611 1.366-3.14z",
    className: "cls-7",
    "data-name": "Pfad 974",
    transform: "translate(-199 -149.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_975",
    d: "M523.195 380.384l-3.341 1.344-3.537-2.129 4.113-2.914z",
    className: "cls-7",
    "data-name": "Pfad 975",
    transform: "translate(-170.701 -122.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_976",
    d: "M424.038 383.062l-.059 4.146-3.991-1.379 1.1-2.845z",
    className: "cls-11",
    "data-name": "Pfad 976",
    transform: "translate(-121.277 -125.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_977",
    d: "M383.522 363.658l-7.683 1.208-.738-7.482 7.521-1.622z",
    className: "cls-8",
    "data-name": "Pfad 977",
    transform: "translate(-98.246 -111.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_978",
    d: "M286.2 633.08l-4.711 3.731-4.857-4.1 5.1-2.111z",
    className: "cls-8",
    "data-name": "Pfad 978",
    transform: "translate(-47.726 -252.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_979",
    d: "M213.026 369.849l2.092 3.519-4.692-.516.584-3.04z",
    className: "cls-10",
    "data-name": "Pfad 979",
    transform: "translate(-13.755 -118.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_980",
    d: "M1778.751 376.792l-1.39.4-.692-1.036 1.371-1.185z",
    className: "cls-10",
    "data-name": "Pfad 980",
    transform: "translate(-817.363 -121.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_981",
    d: "M1713.979 362.16l-.94 6.293-6.239 1.4-.695-7.871z",
    className: "cls-11",
    "data-name": "Pfad 981",
    transform: "translate(-781.158 -114.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_982",
    d: "M1701.7 411.868l.343 1.63-1.711-.38-.328-1.851z",
    className: "cls-8",
    "data-name": "Pfad 982",
    transform: "translate(-778.03 -140.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_983",
    d: "M1656.533 456.129l-2.641 3.946-5.14-1.632 3.195-4.909z",
    className: "cls-9",
    "data-name": "Pfad 983",
    transform: "translate(-751.732 -161.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_984",
    d: "M1608.619 386.245l-1.791.239.638-1.41 1.394-.59z",
    className: "cls-10",
    "data-name": "Pfad 984",
    transform: "translate(-730.221 -126.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_985",
    d: "M1552.135 543.951l-4.489-.16L1546 539.5l4.868-.148z",
    className: "cls-7",
    "data-name": "Pfad 985",
    transform: "translate(-699.012 -205.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_986",
    d: "M1476.485 344.3l-1.1-.3-.284-1.007.977.271z",
    className: "cls-10",
    "data-name": "Pfad 986",
    transform: "translate(-662.634 -104.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_987",
    d: "M1391.911 513.878l-1.811 2.422-3.053-.233 1.487-3.237z",
    className: "cls-7",
    "data-name": "Pfad 987",
    transform: "translate(-617.458 -192.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_988",
    d: "M1365.637 366.356l-3.866 1.957 1.021-4.652 2.885.53z",
    className: "cls-10",
    "data-name": "Pfad 988",
    transform: "translate(-604.487 -115.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_989",
    d: "M1286.977 327.3l-.293.945-1.442-.445.977-1.167z",
    className: "cls-8",
    "data-name": "Pfad 989",
    transform: "translate(-565.222 -96.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_990",
    d: "M1185.792 456.992l-.492 3.566-2.917-1.173.56-2.186z",
    className: "cls-9",
    "data-name": "Pfad 990",
    transform: "translate(-512.446 -163.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_991",
    d: "M1131.843 533.9l-2.518 1.389-1.9-1.234 1.792-1.927z",
    className: "cls-8",
    "data-name": "Pfad 991",
    transform: "translate(-484.247 -202.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_992",
    d: "M1038.97 387.523h-.81l-.151-.662.746-.2z",
    className: "cls-9",
    "data-name": "Pfad 992",
    transform: "translate(-438.371 -127.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_993",
    d: "M965.66 544.444l-2.437 1.335-1.223-2.558 2.913-2.494z",
    className: "cls-9",
    "data-name": "Pfad 993",
    transform: "translate(-399.371 -206.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_994",
    d: "M850.665 368.954l-3.566-.531-.294-3.691 4.788-.417z",
    className: "cls-10",
    "data-name": "Pfad 994",
    transform: "translate(-340.268 -115.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_995",
    d: "M823.545 392.042l-1.023 1.353-.733-1.661 1.252-1.3z",
    className: "cls-9",
    "data-name": "Pfad 995",
    transform: "translate(-327.433 -129.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_996",
    d: "M749.206 537.869l.2 4.908-5.367 2.381-1.03-6.912z",
    className: "cls-8",
    "data-name": "Pfad 996",
    transform: "translate(-287.014 -204.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_997",
    d: "M682.751 473.939l-.214 1.419-1.6-.076.218-1.8z",
    className: "cls-9",
    "data-name": "Pfad 997",
    transform: "translate(-255.164 -171.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_998",
    d: "M648.489 572.586l-2.6 2.036-2.037-1.905 1.869-4.1z",
    className: "cls-9",
    "data-name": "Pfad 998",
    transform: "translate(-236.136 -220.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_999",
    d: "M588.59 349.849l.848 1.892-2.071.264-.32-1.619z",
    className: "cls-7",
    "data-name": "Pfad 999",
    transform: "translate(-206.992 -108.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1000",
    d: "M509.1 456.9l-1.8-.471.848-1.653 1.327.676z",
    className: "cls-11",
    "data-name": "Pfad 1000",
    transform: "translate(-166.076 -162.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1001",
    d: "M456.6 564.988l-1.477-.521.785-1.111 1.405.182z",
    className: "cls-10",
    "data-name": "Pfad 1001",
    transform: "translate(-139.303 -218.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1002",
    d: "M368.494 490.462l-.532 4.743-5.943-2.971 4.035-4z",
    className: "cls-7",
    "data-name": "Pfad 1002",
    transform: "translate(-91.534 -179.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1003",
    d: "M287.319 570.812l-2.8 1.2-.106-2.751 2.331-1.422z",
    className: "cls-9",
    "data-name": "Pfad 1003",
    transform: "translate(-51.718 -220.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1004",
    d: "M193.94 400.791l-4.31 1.076-.961-4.122 4.627-2.223z",
    className: "cls-10",
    "data-name": "Pfad 1004",
    transform: "translate(-2.592 -131.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1005",
    d: "M1708.521 654.464l-3.542 1.615-.62-3.93 3.935-2.027z",
    className: "cls-8",
    "data-name": "Pfad 1005",
    transform: "translate(-780.263 -262.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1006",
    d: "M1585.591 638.2l-2.28 4.68-4.347-1.5 1.073-5.327z",
    className: "cls-10",
    "data-name": "Pfad 1006",
    transform: "translate(-715.925 -255.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1007",
    d: "M1515.339 560.3l-5.686-1.449 1.034-3.7 2.677.349z",
    className: "cls-10",
    "data-name": "Pfad 1007",
    transform: "translate(-680.363 -213.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1008",
    d: "M1383.3 621.361l-4.025-2.736 2.364-2.745 2.4 1.3z",
    className: "cls-10",
    "data-name": "Pfad 1008",
    transform: "translate(-613.469 -244.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1009",
    d: "M1379.909 568.106l-.719 1.6-.852-1.217.206-1.436z",
    className: "cls-10",
    "data-name": "Pfad 1009",
    transform: "translate(-612.987 -219.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1010",
    d: "M1263.02 523.012l-.552 3.2-2.417-1.737.2-2.762z",
    className: "cls-10",
    "data-name": "Pfad 1010",
    transform: "translate(-552.297 -196.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1011",
    d: "M1169.21 441.579l-2.349-1.33 1.015-1.737 2.583.172z",
    className: "cls-9",
    "data-name": "Pfad 1011",
    transform: "translate(-504.482 -153.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1012",
    d: "M1120 431.9l-2.2-.142.874-2.588 2.739.837z",
    className: "cls-10",
    "data-name": "Pfad 1012",
    transform: "translate(-479.31 -149.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1013",
    d: "M1071.984 340.528l-2.245 3.886-4.582-1.234 2.544-4.012z",
    className: "cls-7",
    "data-name": "Pfad 1013",
    transform: "translate(-452.3 -103.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1014",
    d: "M1020.143 391.13l-.47 3.058-2.337-1.525-.056-2.857z",
    className: "cls-7",
    "data-name": "Pfad 1014",
    transform: "translate(-427.736 -128.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1015",
    d: "M908.094 439l-4.152-.934 2.129-3.33 3.6.612z",
    className: "cls-9",
    "data-name": "Pfad 1015",
    transform: "translate(-369.584 -152.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1016",
    d: "M904.169 338.94l-1.733 4.06-2.916.6.491-3.019z",
    className: "cls-10",
    "data-name": "Pfad 1016",
    transform: "translate(-367.315 -102.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1017",
    d: "M817.463 432.937l-4.828 1.881-2.419-5.872 6.631-1.778z",
    className: "cls-8",
    "data-name": "Pfad 1017",
    transform: "translate(-321.495 -148.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1018",
    d: "M730.893 594.714l.423 1.235-1.61-.309.088-1.641z",
    className: "cls-9",
    "data-name": "Pfad 1018",
    transform: "translate(-280.187 -233.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1019",
    d: "M634.664 464.051l-.1 2.058-1.945.188-.461-2.373z",
    className: "cls-9",
    "data-name": "Pfad 1019",
    transform: "translate(-230.14 -167.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1020",
    d: "M541.4 349.8l-1.066-.236.052-1.079 1.277.053z",
    className: "cls-7",
    "data-name": "Pfad 1020",
    transform: "translate(-183.025 -107.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1021",
    d: "M494.529 327.143L492.2 328.3l-1.5-2.291 2.335-.537z",
    className: "cls-10",
    "data-name": "Pfad 1021",
    transform: "translate(-157.56 -95.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1022",
    d: "M386.255 370.454l-5.425 1.314-2.9-4.94 5.953-2.075z",
    className: "cls-8",
    "data-name": "Pfad 1022",
    transform: "translate(-99.7 -116.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1023",
    d: "M278.07 388.361l-.507.578-.514-.279.16-.93z",
    className: "cls-8",
    "data-name": "Pfad 1023",
    transform: "translate(-47.937 -127.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1024",
    d: "M236.609 412.6l-3.4.305.394-3.672 2.511 1.08z",
    className: "cls-8",
    "data-name": "Pfad 1024",
    transform: "translate(-25.445 -138.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1025",
    d: "M206.625 483.344l-1.18.288-.025-1.283 1.177-.114z",
    className: "cls-8",
    "data-name": "Pfad 1025",
    transform: "translate(-11.186 -176.413)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.495d9c4714b297f1f330336aa3864667.svg";
export { ForwardRef as ReactComponent };